import { useMemo } from 'react';
import { dishMatchesCategory } from '../utils/dishHelpers';

/**
 * Custom hook for filtering dishes based on category and search query
 * @param {Array} dishes - Array of dish objects
 * @param {string} activeCategory - Currently selected category id
 * @param {string} searchQuery - Search query string
 * @param {Array} categories - Category objects used for flexible id/name matching
 * @returns {Array} Filtered dishes
 */
export const useDishFilters = (dishes, activeCategory, searchQuery, categories = []) => {
  return useMemo(() => {
    let filtered = dishes;

    // Filter by category
    if (activeCategory !== 'all') {
      const selectedCategory = categories?.find((category) => category?.id === activeCategory);
      filtered = filtered?.filter((dish) => dishMatchesCategory(dish?.category, selectedCategory || { id: activeCategory }));
    }

    // Filter by search query
    if (searchQuery?.trim()) {
      const query = searchQuery?.toLowerCase();
      filtered = filtered?.filter(dish => 
        dish?.name?.toLowerCase()?.includes(query) ||
        dish?.description?.toLowerCase()?.includes(query) ||
        dish?.ingredients?.some(ingredient => ingredient?.toLowerCase()?.includes(query))
      );
    }

    return filtered;
  }, [dishes, activeCategory, searchQuery, categories]);
};

export default useDishFilters;